import { SET_SHARE_WECHAT } from '../../store/mutationTypes';
export default {
  props: {},
  data() {
    return {
      visible: false
    };
  },
  computed: {
    shareWechat() {
      return this.$store.state.shareWechat;
    }
  },
  methods: {
    handlerClose() {
      this.$store.commit(SET_SHARE_WECHAT, false);
    }
  },
  created() {},
  mounted() {},
  beforeUnmount() {},
  watch: {}
};